import * as React from "react";
const SvgCheckboxPartitialIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 2, viewBox: "0 0 8 2", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { width: 8, height: 2, fill: "#B3A6A6" }));
export default SvgCheckboxPartitialIcon;
